export const USER_TYPES = {
  user: 'User',
  field_agent: 'Field-Agent',
  superuser: 'SuperUser',
  farmer: 'Farmer',
  superadmin: 'SuperAdmin',
  admin: 'Admin',
};

export const CREATABLE_USER_TYPES = {
  [USER_TYPES.superuser]: [USER_TYPES.superadmin],
  [USER_TYPES.superadmin]: [USER_TYPES.admin, USER_TYPES.user],
  [USER_TYPES.admin]: [USER_TYPES.user],
};

export const FILTERABLE_USER_TYPES = {
  [USER_TYPES.superuser]: [
    USER_TYPES.superadmin,
    USER_TYPES.admin,
    USER_TYPES.user,
  ],
  [USER_TYPES.superadmin]: [USER_TYPES.admin, USER_TYPES.user],
  [USER_TYPES.admin]: [USER_TYPES.user],
};

export const PROJECT_SCOPED_USER_TYPES = [
  USER_TYPES.user,
  USER_TYPES.field_agent,
  USER_TYPES.farmer,
];

export const isSuperUser = (userType) => userType === USER_TYPES.superuser;

export const PROJECT_MANAGER_USER_TYPES = [USER_TYPES.superadmin];

export const canManageUser = (actorType, targetType) =>
  !isSuperUser(actorType) || targetType === USER_TYPES.superadmin;

export const canManageProjects = (userType) =>
  PROJECT_MANAGER_USER_TYPES.includes(userType);

export const canManageFarms = (userType) => !isSuperUser(userType);

export const NO_SUB_DISTRICTS_MESSAGES = {
  [USER_TYPES.field_agent]: {
    form: "This field officer won't see any farms, farmers or analytics in the mobile app, and can't create field locations until at least one sub-district is assigned.",
    list: "No sub-districts assigned. This officer can't view farms or create field locations in the mobile app.",
  },
  [USER_TYPES.farmer]: {
    form: "",
    list: "No sub-districts assigned.",
  },
};

export const hasNoSubDistricts = (subDistricts) =>
  !(subDistricts || []).filter(Boolean).length;
